import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IcosInputsModule } from '../input/module'
import { IcosDataPicker } from './picker'
import { IcosDatePickerPanel } from './picker-panel'
import { IcosDateTable } from './children/date-table'
import { IcosYearTable } from './children/year-table'
import { EMonthTable } from './children/month-table'

@NgModule({
  declarations: [IcosDataPicker, IcosDatePickerPanel, IcosDateTable, IcosYearTable, EMonthTable],
  exports: [IcosDataPicker, IcosDatePickerPanel, IcosDateTable, IcosYearTable, EMonthTable],
  imports: [CommonModule, FormsModule,IcosInputsModule],
  entryComponents: [IcosDataPicker],
})
export class IcosDateModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosDateModule, providers: [] }
  }
}
